    <div class="container-fluid page-content">

        <div class="row">
            <div class="col">
                <label class="title">Compañias</label>
            </div>
        </div>

        <div class="row">
            <div class="col text-end">
                <button (click)="abrirModalInsertarCompania()" class="btn btn-sm btn-success rounded-button">
                    <i class="fas fa-plus"></i>&nbsp;
                    Nueva compañia
                </button>
            </div>
        </div>

        <div class="row mt-3">
            <p-table #dt [value]="listaCompanias" [scrollable]="true" [scrollHeight]="'calc(100vh - 260px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">

                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th pSortableColumn="usuario" class="medium-col" style="border-top-left-radius: 15px;">No. de empleado</th> -->
                        <th pSortableColumn="clave" class="medium-col" style="border-top-left-radius: 15px;">Clave</th>
                        <th pSortableColumn="descripcion" class="medium-col">Descripcion</th>
                        <!-- <th pSortableColumn="apellidoMaterno" class="medium-col">Apellido materno</th>
                        <th pSortableColumn="rol" class="medium-col">Rol</th>
                        <th pSortableColumn="IATA" class="medium-col">Estación</th>-->
                        <th class="medium-col" style="border-top-right-radius: 15px;">Accion</th>
                    </tr>

                    <tr class="filter-row">
                        <th>
                            <input placeholder="Filtrar" type="text" #filtroClave class="form-input form-input-table-filter" (input)="dt.filter(filtroClave.value, 'clave', 'contains')">
                        </th>

                        <th class="filter-row">
                            <input placeholder="Filtrar" #filtroDescripcion type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroDescripcion.value, 'descripcion', 'contains')">

                        </th>

                        <th></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" class="animated fadeIn fast" let-compania>

                    <tr>
                        <td class="medium-col">{{compania.clave }}</td>
                        <td class="medium-col">{{compania.descripcion}}</td>
                        <td class="medium-col">
                            <button type="button" (click)="abrirModalEditarCompania(compania)" style="font-size:12px; width: 100px;" class="btn btn-xs my-button-blue-outline rounded-button">
                                <i class="far fa-edit"></i>&nbsp;
                                Editar
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

        </div>

    </div>